.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--gap);
}

.tile {
  display: block;
  width: 100%;
  padding: 14px;
  text-align: left;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.tile:active:not(:disabled) {
  background: var(--surface-sunken);
}

.tile:disabled {
  opacity: 0.5;
  cursor: default;
}

.icon {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  margin-bottom: 10px;
  color: var(--ink-soft);
  background: var(--surface-sunken);
  border: 1px solid var(--card-border);
  border-radius: var(--r-sm);
}

/* Одна строка: «Пригласить друга» в две строки делал плитки разной
   высоты по смыслу, а не по содержанию. */
.title {
  display: block;
  overflow: hidden;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.hint {
  display: block;
  margin-top: 2px;
  font-size: 13px;
  color: var(--muted);
}
